import React from 'react';
import Layout from 'gatsby-theme-core/src/layout/layout';
// we neeed to import blocks first for the css ordering to not error
import Blocks from '../../blocks'; // eslint-disable-line import/order
import BeforeContent from 'gatsby-theme-pagebuilder/src/components/before-content';
import AfterContent from 'gatsby-theme-pagebuilder/src/components/after-content';

const Page = ({
  data,
  children,
}) => {
  const {
    meta,
    slug,
    blocks,
    disableBlocks = false,
    pagebuilderSectionsBeforeContent,
    pagebuilderSectionsAfterContent,
  } = data.page || {};

  const head = {
    headPageTitle: meta.pageTitle,
    headTitle: meta.metaTitle,
    headSlug: slug,
    headMetaDescription: meta.metaDescription,
    headImage: meta.metaImage,
    headNoindex: meta.noindex,
  };
  return (
    <Layout {...head}>
      <BeforeContent pagebuilderSectionsBeforeContent={pagebuilderSectionsBeforeContent} />
      {!disableBlocks && (
        <Blocks
          blocks={blocks}
          products={data.products}
          meta={meta}
        />
      )}
      {children}
      <AfterContent pagebuilderSectionsAfterContent={pagebuilderSectionsAfterContent} />
    </Layout>
  );
};

export default Page;
